import './styles/mobile_audits.scss';

import React, { useEffect, useState, useRef } from "react";
import type { TableProps } from "antd";
import { ColumnsType, ColumnType } from "antd/es/table";
import {
  Form,
  Input,
  Upload,
  Popconfirm,
  Table,
  Typography as Typographys,
  Button as Buttons,
  Select,
  notification,
  Space,
  Tag,
} from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import AuditsController from "./Controller/audits_controller.ts";
import CustomSeparator from "./../../layouts/AdminLayout/Header/Breadcrumbs.js";
import Typography from "@mui/material/Typography";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { createStyles } from "antd-style";
import {
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@mui/material";
import MobileAuditExcel from "./excel/mobile_audit_excel.jsx";

//i-components
import SelectionBox from '../../i-components/SelectionBox.tsx';

//i-classes
import SelectionList from '../../i-classes/selectionList.tsx';

const useStyle = createStyles(({ css }) => {
  return {
    customTable: css`
      .ant-table {
        .ant-table-container {
          .ant-table-body,
          .ant-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface DataType {
  key: string;
  ID: string;
  full_name: string;
  audit_action: string;
  action_datetime: any;
}

type DataIndex = keyof DataType;

const CheckboxList = ({ columns, onChange, checkedColumns }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // State for checkboxes, synchronized with `checkedColumns` from parent
  const [checked, setChecked] = useState(checkedColumns);

  useEffect(() => {
    setChecked(checkedColumns); // Synchronize state with prop
  }, [checkedColumns]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    onChange(newChecked); // Notify parent about changes
  };

  return (
    <>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        style={{ backgroundColor: "#d33333" }}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "20ch",
          },
        }}
      >
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        >
          {columns.map((value) => {
            const labelId = `checkbox-list-label-${value.dataIndex}`;
            return (
              <ListItem key={value.dataIndex} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={handleToggle(value.dataIndex)}
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={checked.includes(value.dataIndex)}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.title} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Menu>
    </>
  );
};

const App: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [rows, setRows] = useState<any[]>([]);
  const [data, setData] = useState<DataType[]>(rows);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  //states
  const [SelectionList_auditActions, SetSelectionList_auditActions] = useState<SelectionList[]>([] as SelectionList[]);
  const [filter_auditAction, SetFilter_auditAction] = useState<string>('All');

  useEffect(() => {
    AuditsController.getMobileAudits().then((response) => {
      console.log(response);
      const rowData = response.map((item, index) => ({
        key: index,
        ID: index + 1,
        full_name: item.name,
        audit_action: item.action_label,
        action_datetime: item.datetime_created,
      }));

      const rowDataArr = Array.from(rowData);
      setRows(rowDataArr);

      const _selectionList_auditActions = [] as SelectionList[];
      _selectionList_auditActions.push(new SelectionList('All', 'All'));

      rowDataArr.map((rowData: any) => {
        let listExist = false;
        _selectionList_auditActions.map((selectionList: SelectionList) => {
          if(selectionList.key == rowData.audit_action)
            listExist = true;
        });

        if(!listExist) {
          _selectionList_auditActions.push(new SelectionList(rowData.audit_action, rowData.audit_action));
        }
      });
      SetSelectionList_auditActions([..._selectionList_auditActions]);
    });
  }, []);

  // **************************** SEARCH FILTER ANTD TABLE *****************************************************
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Buttons
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Buttons>
          <Buttons
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Buttons>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (open) => {
      if (open) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  // ************************************************************************************************************

  const columns = [
    {
      title: "No.",
      dataIndex: "ID",
      key: "ID",
      width: "15%",
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      ...getColumnSearchProps("full_name"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Audit Actions",
      dataIndex: "audit_action",
      ...getColumnSearchProps("audit_action"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Action DateTime",
      dataIndex: "action_datetime",
    },
  ];

  const [checkedColumns, setCheckedColumns] = useState([
    "ID",
    "action_datetime",
    "audit_action",
    "full_name",
  ]);

  const onChange = (checkedValues) => {
    setCheckedColumns(checkedValues);
  };

  const mergedColumns = columns
    .filter(
      (col) =>
        typeof col.dataIndex === "string" &&
        checkedColumns.includes(col.dataIndex)
    )
    .map((col) => {
      return {
        ...col,
        onCell: (record: DataType) => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
        }),
      };
    });

  const { styles } = useStyle();

  //filter function
  const FilterRowsByAuditAction = (rows: any[]) => {
    const filtered = [] as any;
    rows.map((row: any) => {
      if(filter_auditAction == 'All' || row.audit_action == filter_auditAction) {
        filtered.push(row);
      }
    });
    return filtered;
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "100%", // scroll y for page
          minHeight: "150vh",
          width: "100vw", // Full viewport width
          overflow: "hidden", // Ensure no overflow from the Box itself
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex", // Ensures the table fills the remaining space
            flexDirection: "column",
            height: "100%", // Fill remaining height
            width: "100%", // Fill remaining width
          }}
        >
          <DrawerHeader />
          <CustomSeparator pageName="mobile_audits" />
          {contextHolder}

          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Super App Audits Directory
          </Typography>
          <Stack spacing={2} direction="row" sx={{ mb: 3 }}>
            <CheckboxList
              columns={columns}
              checkedColumns={checkedColumns}
              onChange={onChange}
            />
            <MobileAuditExcel />
            <SelectionBox className='audit-select' selectionList={SelectionList_auditActions} selectingKey={filter_auditAction} SetSelectingKey={SetFilter_auditAction}/>
          </Stack>

          {/* Box to hold the table with full width/height */}
          <Box
            sx={{
              flexGrow: 1, // Ensures the table box expands
              backgroundColor: "#fff", // Set the background color for the table container
              height: "100%", // Ensures the table fills available height
              width: "100%", // Ensures the table fills available width
              overflow: "auto", // Allow scrolling if needed
              borderRadius: "8px", // Optional: for rounded corners
            }}
          >
            <Form form={form} component={false}>
              <Table<DataType>
                className={styles.customTable}
                bordered
                dataSource={FilterRowsByAuditAction(rows)}
                columns={mergedColumns as ColumnType<DataType>[]}
                rowClassName="editable-row"
                scroll={{ x: "80vh", y: 150 * 5 }}
              />
            </Form>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default App;
